const translations = {
    plan: {
        type: 'text',
        defaultValue: 'Pakiet:',
    },
    price: {
        type: 'text',
        defaultValue: '/msc',
    },
    free: {
        type: 'text',
        defaultValue: 'ZA DARMO!',
    },
    listDetails: {
        type: 'text',
        defaultValue: 'Szczegóły Planu:',
    },
    buyNowButton: {
        type: 'text',
        defaultValue: 'Aktywuje i płacę',
    },
    active: {
        type: 'text',
        defaultValue: 'Zobacz i aktywuj',
    },
    functionalPlan: {
        type: 'text',
        defaultValue: 'Funkcje planu:',
    },
    status: {
        type: 'text',
        defaultValue: 'Status:',
    },
};

export default translations;
